import {Component, Input} from '@angular/core';
import {AjaxService} from 'AjaxService';
import DataSource from 'devextreme/data/data_source';
import {MeldungEoEStatus, MeldungEoEReadStatus} from '@enums/meldungEoEStatus.enum';
import {Roles} from '@enums/roles.enum';
import {AuthService} from 'AuthService';
import CustomStore from 'devextreme/data/custom_store';
import {Router} from '@angular/router';
import {lastValueFrom} from 'rxjs';

interface IMeldungenEntityEoEResultViewModel {
  items: IMeldungEntityEoETableItem[];
  totalItems: number;
}

interface IMeldungEntityEoETableItem {
  id: number;
  einrichtungId: number;
  traegerId: number;
  meldeDatum: Date;
  vorkommnisDatum: Date;
  ort: string;
  vorkommnisArt: string;
  schweregrad: string;
  schweregradFarbe: string;
}

interface IMeldungEntityEoESearchRequestViewModel {
  ownerId: number;
  forHE: boolean;
  searchText: string;
  skip: number;
  take: number;
  sortColumn: string;
  sortDirection: boolean;
  bearbeitungsStatus: number[];
  readStatus: number[];
}

@Component({
    selector: 'cz-mEoE',
    templateUrl: 'mEoE.component.html',
    styleUrls: ['./mEoE.component.css'],
    standalone: false
})
export class MeldungEntityEoEComponent {
  @Input() ownerId: number;
  @Input() forHE: boolean = false;

  get darfInterneEoEAnlegen(): boolean {
    return !this.forHE && Number.isSafeInteger(this.ownerId) && this.ownerId > 0
      && this.authService.darfInterneEoEBearbeiten();
  }

  interneEoEAnlegen() {
    if (!this.darfInterneEoEAnlegen) return;
    this.router.navigate(['/meldungen/eoe/erfassen', 0], {queryParams: {eId: this.ownerId}});
  }

  // _useHE: boolean = false;
  // get useHE(): boolean {
  //   return this._useHE;
  // }

  // set useHE(val: boolean) {
  //   if (val !== this._useHE) {
  //     this._useHE = val;
  //     this.dataSource.reload();
  //   }
  // }

  dataSource: any = {};

  available_bearbeitungsStatus: any[] = MeldungEoEStatus.keys().map(x => ({...x, name: ['Entwurf / Nicht eingereicht', 'In Bearbeitung / Eingereicht', 'Erledigt'][x.id]}));
  available_readStatus: any[] = MeldungEoEReadStatus.keys();
  selectedBearbeitungsStatus: number[] = [this.available_bearbeitungsStatus[1].id, this.available_bearbeitungsStatus[2].id];
  selectedReadStatus: number[] = [this.available_readStatus[0].id];

  constructor(private _ajaxService: AjaxService, private router: Router, public authService: AuthService) {
    const self = this;
    if (this.authService.hasOneRole([Roles.Meldungen_Lesen])) {
      this.dataSource = new DataSource({
        load: function (loadOptions: any) {
          if (!loadOptions.searchOperation) {
            return;
          }

          loadOptions.userData = {
            ownerId: self.ownerId,
            // forHE: self.useHE,
            bearbeitungsStatus: self.selectedBearbeitungsStatus,
            readStatus: self.selectedReadStatus,
          };

          return lastValueFrom(self._ajaxService.post<any>('api/TraegerInternMeldungenEoE/SearchMeldungenEoeForTab', loadOptions));
        },
      });
    }
  }

  changeDropDownBoxValue(event) {
    this.dataSource.reload();
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;
    const searchPanel = toolbarItems.filter((item) => item.name === 'searchPanel');

    if (searchPanel && searchPanel[0]) {
      searchPanel[0].location = 'before';
    }

    e.toolbarOptions.items.push({
      location: 'before',
      template: 'searchBarTemplate1',
    });

    e.toolbarOptions.items.push({
      location: 'before',
      template: 'searchBarTemplate2',
    });

    e.toolbarOptions.items.push({
      location: 'after',
      locateInMenu: 'never',
      template: 'interneEoEAnlegenTemplate',
    });

    // if (this.forHE) {
    //   e.toolbarOptions.items.push({
    //     location: 'before',
    //     template: 'searchBarTemplate3',
    //   });
    // }
  }

  onContentReady(e) {
    e.component.columnOption('command:edit', {
      visibleIndex: -1,
    });
  }

  onEditingStart(e) {
    e.cancel = true;

    this.router.navigate(['/meldungen/eoe/edit', e.data.id]);
  }

  readStatus_calculateCellValue(row) {
    return MeldungEoEReadStatus.getValues()[row.readStatus].toString();
  }

  bearbeitungsStatus_calculateCellValue(row) {
    if (row.istInternErfasst) return ['Entwurf', 'In Bearbeitung', 'Erledigt'][row.bearbeitungsStatus];
    return MeldungEoEStatus.getValues()[row.bearbeitungsStatus].toString();
  }
}
